import React, { useEffect, useState } from "react";
import { getToken } from "../services/Token";
import { useLazyGetTenantDetailsQuery } from "../api/tenantApi";
import { useDispatch } from "react-redux";
import { setLogoUrl } from "../store/reducers/calendarSlice";
import { Dialog, DialogContent, Alert, Snackbar } from "@mui/material";
import axios from "axios";
import { genericHeaders, serviceUrl } from "../utils/apiConfig";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import PaySlipEmployee from "./paySlipEmployee";
import {
  setPaySlipData,
  setEmployeeAudiData,
} from "../store/reducers/payrollSlice";
import {
  useLazyPayslipQuery,
  useLazyEmployeeAuditQuery,
  useSigninstatusQuery,
} from "../api/loginApi";
import SignInTrackingCard from "./SignInTrackingCard";
import EngageHighlights from "./Engage/EngageHighlights";
import ReviewCard from "./Review/adminReviewCard";
import AadharPanDocumentUpload from "./PatchWork/aadharPanDocumentUpload";
import { usePanAadharCheckQuery } from "../api/panAadharCheckAPI";
import GreetingTile from "./DashboardTiles/GreetingTile";
import AttendanceTile from "./DashboardTiles/AttendanceTile";
import AttendanceDialog from "./DashboardTiles/AttendanceDialog";
const EmployeeMessage = () => {
  const [snack, setSnack] = useState({
    open: false,
    error: false,
    message: "",
  });
  const loggedInUserId = getToken("Id");
  const [getTenantDetails, { data }] = useLazyGetTenantDetailsQuery();
  const employeeName = getToken("employeeName");
  const role = getToken("roles");
  const isAdmin = role ? role.includes("ADMIN") || role.includes("PROXY_ADMIN") : false;
  const isManager = role ? role.includes("MANAGER") : false;
  const isEmployee = role ? role.includes("EMPLOYE") : false;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [comments, setComments] = useState("");
  const [signIn, setSignIn] = useState("");
  const [signOut, setSignOut] = useState("");
  const [Location, setLocation] = useState("");
  const loggedIn = localStorage.getItem("loggedIn");
  const [isLoading, setIsLoading] = useState(false);
  const tenantCountry = getToken("tenantCountry");
  const {data:panAadharStatus, isSuccess:panAadharSuccess} = usePanAadharCheckQuery({}, {refetchOnMountOrArgChange:true})
  const [shouldShowPanAadharPopUp, setShouldShowPanAadharPopUp] = useState(true)
  const [payslip, { data: payslipdata, isSuccess, isError, error }] =
    useLazyPayslipQuery({});
  const [
    employeeAudit,
    { data: employeeAuditData, isSuccess: employeeAuditDataSuccess },
  ] = useLazyEmployeeAuditQuery({});

  const dispatch = useDispatch();
  const attendanceLogin = localStorage.getItem("loggedInToday");
  const lastLoggedInTime = localStorage.getItem("lastLoggedInTime");

  const notSignedIn =
    (attendanceLogin === "LOGGEDOUT" && !signIn) || loggedIn === "LOGGEDOUT";
  const currentlySignedIn =
    !notSignedIn &&
    ((attendanceLogin === "LOGGEDIN" && !signOut) ||
      loggedIn === "LOGGEDIN" ||
      (attendanceLogin === "LOGGEDOUT" && signIn));
  const attendanceStatus = notSignedIn
    ? "OUT"
    : currentlySignedIn
    ? "IN"
    : "IDLE";
  const showAttendance = !isAdmin;
  const showReview = isAdmin || isManager;
  const showPaySlip = showAttendance && tenantCountry !== "USA";
  if (data) {
    dispatch(setLogoUrl(data?.logoUrl));
  }

  useEffect(() => {
  getTenantDetails(loggedInUserId);

  if (isAdmin || isManager) {
    const currentDate = dayjs();
    const formatted = currentDate.toISOString();
    employeeAudit(formatted);
  }

  getSignInstatus();
}, []);


  const handleDialogueOpen = () => {
    setDialogOpen(true);
  };
  const handleClose = () => {
    setIsLoading(false);
    setDialogOpen(false);
    setDropdownValue("");
    setComments("");
  };
  useEffect(() => {
    if (isSuccess) {
      dispatch(setPaySlipData(payslipdata));
      localStorage.setItem(
        "paySlipDate",
        payslipdata?.data?.payRollProcessedDate
      );
    } else {
      dispatch(setPaySlipData(error?.data?.message));
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if (employeeAuditDataSuccess) {
      dispatch(setEmployeeAudiData(employeeAuditData));
    }
  }, [employeeAuditDataSuccess]);

  const getSignInstatus = async () => {
    try {
      let response = await axios.get(
        `${serviceUrl}/api/employee/audit/signinstatus`,
        { headers: genericHeaders() }
      );
      
      if(response.status===200){
        localStorage.setItem("loggedIn", response?.data.data?.isloggedintoday);
      localStorage.setItem(
        "lastLoggedInTime",
        response?.data.data?.lastloggedintime
      );
      setLocation(response?.data.data?.lastloggedinlocation);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleDialogueCloseSignIn = async () => {
    try {
      localStorage.setItem("loggedInToday", "LOGGEDIN");
      setIsLoading(true);
      if (dropdownValue !== "Select") {
        if (dropdownValue !== "") {
          let response = await axios.post(
            `${serviceUrl}/api/employee/audit/signin?location=${dropdownValue}&comment=${comments}`,
            null,
            { headers: genericHeaders() }
          );
          if (response.status === 200) {
            setIsLoading(false);
            localStorage.setItem("loggedIn", response?.data?.data?.loginStatus);
            localStorage.setItem(
              "lastLoggedInTime",
              response?.data?.data?.date
            );
            setLocation(response?.data?.data?.location);
            setDropdownValue("");
            setComments("");
            setSignIn(response);
            handleSnackOpen(true, false, response?.data?.message);
            setDialogOpen(false);
          }
        }
      }
    } catch (err) {
      setIsLoading(false);
      handleSnackOpen(true, true, "Something Went Wrong");
      setSignIn(false);
      console.error(err);
    }
  };
  const handleDialogueCloseSignOut = async () => {
    setIsLoading(true);
    try {
      if (dropdownValue !== "Select") {
        if (dropdownValue !== "") {
          let response = await axios.post(
            `${serviceUrl}/api/employee/audit/signout?location=${dropdownValue}&comment=${comments}`,
            null,
            { headers: genericHeaders() }
          );
          if (response.status === 200) {
            setIsLoading(false);
            localStorage.setItem("loggedIn", response?.data?.data?.loginStatus);
            setDropdownValue("");
            setComments("");
            setSignOut(true);
            setDialogOpen(false);
            handleSnackOpen(true, false, response?.data?.message);
          }
        }
      }
    } catch (err) {
      setIsLoading(false);
      handleSnackOpen(true, true, "Something Went Wrong");
      setSignOut(false);
      console.error(err);
    }
  };

  dayjs.extend(duration);

  const formatDate = (dateString) => {
    const date = dayjs(dateString);
    const updatedDate = date.add(dayjs.duration({ hours: 5, minutes: 30 }));

    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };

    return updatedDate.toDate().toLocaleString("en-US", options);
  };

  const handleSnackOpen = (snackopen, err, msg) => {
    setSnack({
      open: snackopen,
      error: err,
      message: msg,
    });
  };
  const handleSnackClose = () => {
    setSnack({
      open: false,
      error: false,
      message: "",
    });
  };
  useEffect(() => {
    if (!isAdmin) {
      payslip(loggedInUserId);
    }
  }, []);

  useEffect(()=>{
    if(panAadharStatus && panAadharSuccess){
      setShouldShowPanAadharPopUp(panAadharStatus.data)
    }
  },[panAadharStatus,panAadharSuccess])

  return (
    <>
      <Dialog
        open={!isAdmin && tenantCountry !== "USA" && !shouldShowPanAadharPopUp}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            width: "30%",
          },
        }}
      >
        <div className="flex justify-between items-center bg-blue-100 p-4">
          <h1 className="text-blue-500 font-bold font-serif text-2xl">
            Please Upload the below Documents to proceed.
          </h1>
        </div>
        <DialogContent>
          <AadharPanDocumentUpload closeDialoge={setShouldShowPanAadharPopUp} />
        </DialogContent>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={snack.open}
        autoHideDuration={3000}
        onClose={handleSnackClose}
      >
        <Alert
          severity={snack.error ? "error" : "success"}
          variant="filled"
          onClose={handleSnackClose}
        >
          {snack.message}
        </Alert>
      </Snackbar>
      <div className="min-h-screen w-full bg-gray-50 px-4 py-6 sm:px-6 lg:px-8">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-5 lg:grid-cols-6">
          <GreetingTile
            employeeName={employeeName}
            address={data?.address}
            className={showAttendance ? "lg:col-span-4" : "lg:col-span-6"}
          />
          {showAttendance && (
            <AttendanceTile
              status={attendanceStatus}
              location={Location}
              lastInLabel={lastLoggedInTime ? formatDate(lastLoggedInTime) : ""}
              onAction={handleDialogueOpen}
              className="lg:col-span-2 lg:row-span-2"
            />
          )}
          {showReview && (
            <ReviewCard
              className={showAttendance ? "lg:col-span-2" : "lg:col-span-3"}
            />
          )}
          {showReview && (
            <SignInTrackingCard
              className={showAttendance ? "lg:col-span-2" : "lg:col-span-3"}
            />
          )}
          {showPaySlip && (
            <PaySlipEmployee
              isError={isError}
              className={showReview ? "lg:col-span-6" : "lg:col-span-4"}
            />
          )}
          <EngageHighlights className="lg:col-span-6" />
        </div>
      </div>
      {showAttendance && (
        <AttendanceDialog
          open={dialogOpen}
          mode={attendanceStatus === "IN" ? "OUT" : "IN"}
          isLoading={isLoading}
          dropdownValue={dropdownValue}
          comments={comments}
          onClose={handleClose}
          onLocationChange={setDropdownValue}
          onCommentsChange={setComments}
          onSubmit={
            attendanceStatus === "IN"
              ? handleDialogueCloseSignOut
              : handleDialogueCloseSignIn
          }
        />
      )}
    </>
  );
};

export default EmployeeMessage;
